import React, { useEffect, useRef } from "react";
import { ThemeContext } from "../theme/Theme.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface MessageProps {
	message: any,
	noPadding?: boolean,
	index?: number,
	onRemoveMessage?: any
}

function Message(props: MessageProps) {
	const context: any = React.useContext(ThemeContext);
	const msg = props.message;
	let color: string;
	let background: string;
	switch (msg.type) {
		case 'error':
			color = context.themeManager.valueOrDefault(msg.type, 'color', 'fg-color-text-highlight', '#F8F8F8');
			background = context.themeManager.valueOrDefault(msg.type, 'background', 'bg-color-zig-zag-box', '#484848');
			break;
		case 'success':
			color = context.themeManager.valueOrDefault(msg.type, 'color', null, '#000000');
			background = context.themeManager.valueOrDefault(msg.type, 'background', null, '#EAEAEA');
			break;
		default:
			color = context.themeManager.value(msg.type, 'color', 'fg-color-text');
			background = context.themeManager.value(msg.type, 'background', 'bg-color-box');
	}
	
	const style = {
		color,
		padding: '1.8em 2.5em',
		fontSize: '1em',
		background,
		display: 'flex',
		alignItems: 'center',
	};
	
	const styleText = {
		flexGrow: 1,
		marginRight: '1em',
	}
	
	const styleCloseIcon = {
		fontSize: '1.7em',
		color: color,
		'&:focusVisible': {
			outline: 'auto',
		},
	}
	
	if (props.noPadding) {
		// @ts-expect-error The operand of a delete operator must be optional.
		delete style.padding;
	}
	
	const iconStyle = {
		fontSize: '1.7em', marginRight: '0.3em',
	};
	
	const divRef = useRef<HTMLDivElement>(null);
	
	//const dispatch = useDispatch();
	
	useEffect(() => {
		divRef?.current?.focus();
	}, []);
	
	return (
		<div
			style={style}
			{...(props.index === 0 ? {ref: divRef} : {})} tabIndex={0}
		>
			<FontAwesomeIcon
				icon={msg.type === 'success' ? 'check-circle' : 'exclamation-circle'}
				style={iconStyle}
			/>
			<span style={styleText}>{msg.text}</span>
			{props.onRemoveMessage &&
				<button id="close-button" className="leo__button-sample"
						onClick={() => props.onRemoveMessage(msg)} aria-selected="true" aria-labelledby="close">
					<FontAwesomeIcon
						id="close"
						aria-label="Meldung schließen"
						aria-hidden="false"
						title="Meldung schließen"
						icon="times-circle"
						style={styleCloseIcon}
					/>
				</button>
			}
		</div>
	);
}

export default Message

